module.exports = __webpack_public_path__ + "static/beckyheadshot-d0e2817636b3155643ed8aff891f2c9f.jpg";